<template>
    <div class="modal-background"></div>
    <div class="modal-container">

        <v-btn @click="$emit('close-modal')" variant="text" class="close">
            <img src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/34acc885-1b03-4a5a-b827-489477f81a78.svg"
                alt="">
        </v-btn>

        <div v-if="confirmar == false">
            <img style="width: 60%; margin-top: 20px;"
                src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/653a934a-9588-4c0a-ba62-468355367785.svg"
                alt="" class=" modal-img" />
            <p class="modal-title">Está tudo certo?</p>
            <p class="modal-subtitle">Atenção que está ação não pode ser desfeita. <br>Ao confirmar, vamos transformar sua
                trilha para lhe dar toda assistência diante do ocorrido.</p>
            <v-btn color="#660099" @click="confirmar = true" class="text-none btn-action">Comunicar AURA ou Vivo
                Pessoas</v-btn>
        </div>

        <div v-else>
            <img style="width: 70%"
                src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/ee9abc96-e81d-4ff0-b8cd-bfe8bf3bcbb0.svg"
                alt="" class=" modal-img" />
            <v-btn color="#660099" @click="$emit('iniciar-acolhimento')" class="text-none btn-action">Iniciar
                acolhimento</v-btn>
        </div>
    </div>
</template>

<script setup>
import { defineEmits, ref } from 'vue';

const confirmar = ref(false)
defineEmits(["close-modal", "iniciar-acolhimento"])


</script>

<style scoped>
.modal-background {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 5;
    background-color: black;
    opacity: 0.4;
}

.modal-container {
    width: 85%;
    position: absolute;
    top: 15%;
    left: 7.5%;
    border-radius: 12px;
    padding: 30px 0;
    background-color: #fff;

    text-align: center;
    z-index: 5;
}

.modal-title {
    color: #464646;
    font-weight: bold;
    width: 85%;
    margin-left: 7.5%;
}

.modal-subtitle {
    font-size: 10px;
    width: 85%;
    margin-left: 7.5%;
    margin-bottom: 20px;
}

.modal-container .btn-action {
    width: 90%;
    font-size: 13px;
}

.close {
    position: absolute;
    width: 30px;
    left: 75%;
    top: 5%;
}
</style>